"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Spinner = function Spinner() {
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250"
  }, _react.default.createElement("path", {
    fill: "#63DC3E",
    d: "M87.992 143.461H65.617V94.692l22.375-4.02v52.789zM120.133 143.461H97.752V84.033l22.381-4.24v63.668zM152.242 74.353h-22.381v69.108h22.381V74.353zM184.388 143.461h-22.374V83.989l22.374 4.026v55.446zM184.379 153.266h-54.484v22.381h54.484v-22.381z"
  }), _react.default.createElement("path", {
    fill: "#63DC3E",
    d: "M125 250C56.074 250 0 193.926 0 125S56.074 0 125 0s125 56.074 125 125-56.074 125-125 125zm0-225.383C69.648 24.617 24.617 69.648 24.617 125S69.648 225.383 125 225.383 225.383 180.352 225.383 125 180.352 24.617 125 24.617z"
  }));
};

var _default = Spinner;
exports.default = _default;